import { Component } from "@angular/core";
import { FieldType } from "@kre-form/core";
import * as _ from "lodash";
@Component({
  selector: "krefield-number",
  template: `
    <ng-container *ngIf="formStatus !== 0; else other">
      <div class="control-design">
        <input nz-input disabled />
      </div>
    </ng-container>

    <ng-template #other>
      <ng-container *ngIf="editor === true">
        <nz-input-number
          autocomplete="off"
          [formControl]="formControl"
          [nzPlaceHolder]="placeHolder"
          [kreFormAttributes]="field"
          [class.is-invalid]="showError"
          [nzPrecision]="
            to.precision == undefined || to.precision == null
              ? null
              : to.precision
          "
          [nzMax]="to.max || 999999"
          [nzMin]="to.min || -999999"
        ></nz-input-number>
      </ng-container>
      <div class="fieldtext" *ngIf="editor === false">{{ number }}</div>
    </ng-template>
  `,
})
export class KreFormFieldNumber extends FieldType {
  get precision() {
    let result = 0;
    if (
      this.to != undefined &&
      this.to != null &&
      this.to["precision"] != undefined &&
      this.to["precision"] != null
    ) {
      result = this.to["precision"];
    }
    return result;
  }
  get number() {
    let result = this.text;
    if (
      this.to != undefined &&
      this.to != null &&
      this.to["precision"] != undefined &&
      this.to["precision"] != null
    ) {
      if (!!result || result === 0) {
        result = _.round(result, this.to["precision"]);
        if (
          !_.isEmpty(this.model) &&
          (this.model as Object).hasOwnProperty(this.key)
        ) {
          this.model[this.key] = result;
        }
      }
    }
    return result;
  }
}
